import {
  FC,
  useCallback,
  useEffect,
  useState,
  useMemo,
  useRef,
  useContext,
} from "react";

import { Accordion, Modal } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-hot-toast";

import useAxios from "../../../services/useAxios";
import { CustomInput } from "../../kits/Inputs/Inputs";
import CustomButton from "../../kits/button/CustomButton";

import AuthenticationContext from "../../../Authentication/AuthenticationContext";

import PreparedMessagesTable from "./PreparedMessagesTable";

import "./prepared-messages.scss";

import {
  MessageType,
  SelectOptionsType,
  GetPreparedMessagesResponse,
  InsertPreparedMessageRequest,
  InsertResponse,
  UpdatePreparedMessageRequest,
  UpdateResponse,
  UploadImgResponse,
} from "./PrMeTypes";

interface PreparedMessagesModalProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  receiver_id: string;
  selectedContact: { customer_id: string };
}

const PreparedMessagesModal: FC<PreparedMessagesModalProps> = ({
  showModal,
  receiver_id,
  setShowModal,
  selectedContact,
}) => {
  const { userInfo } = useContext(AuthenticationContext);

  const { execute: GetPreparedMessagesAPI } = useAxios(
    "/api/get_prepared_messages"
  );
  const { execute: InsertPreparedMessageAPI } = useAxios(
    "/api/Insert_PreparedMessage"
  );
  const { execute: UpdatePreparedMessageAPI } = useAxios(
    "api/update_PreparedMessage"
  );
  const { execute: UplaodImg } = useAxios("api2/upload_img");

  const [messages, setMessages] = useState<MessageType[]>([]);
  const [categories, setCategories] = useState<SelectOptionsType>([]);
  const [inputs, setInputs] = useState({
    text: "",
    category_id: 0,
    file_id: 0,
  });

  const fileRef = useRef<HTMLInputElement>(null);

  const selectedCategory = useMemo(
    () => categories.find((val) => +val.value === inputs.category_id) || null,
    [categories, inputs.category_id]
  );

  const getData = useCallback(() => {
    GetPreparedMessagesAPI().then((res: GetPreparedMessagesResponse) => {
      setCategories(
        Object.keys(res.categories).map((val) => ({
          label: res.categories[val],
          value: "" + val,
        }))
      );
      setMessages(
        res.messages.map((val) => ({
          id: +val.id,
          text: val.text,
          category_id: +val.category_id,
          category_title: val.category_title,
          file_id: +val.file_id,
          file_path: val.file_path,
          mtm: val.mtm,
        }))
      );
    });
  }, [GetPreparedMessagesAPI]);

  const resetInputs = useCallback(() => {
    setInputs({
      text: "",
      category_id: 0,
      file_id: 0,
    });
  }, []);

  const fileHandler = useCallback<React.ChangeEventHandler<HTMLInputElement>>(
    (event) => {
      if (event.target.files !== null && event.target.files.length !== 0) {
        // @ts-ignore
        UplaodImg({ file: event.target.files[0] }).then(
          (res: UploadImgResponse) => {
            if (res.result) {
              setInputs((prev) => ({ ...prev, file_id: res.result.id }));
            }
          }
        );
      }
    },
    []
  );

  const deleteMessage = useCallback(
    (id: number) => {
      let data: UpdatePreparedMessageRequest = {
        conditions: `id/=/${id}`,
        keyvalues: "status,-1",
      };

      UpdatePreparedMessageAPI(data).then((res: UpdateResponse) => {
        if (res.status === 1) {
          toast.success("پیام با موفقیت حذف شد.");
          getData();
        } else {
          toast.error("مشکلی در حذف پیام بوجود آمده است. لطفا بعدا تلاش کنید.");
        }
      });
    },
    [getData, UpdatePreparedMessageAPI]
  );

  const submitForm = useCallback<React.FormEventHandler>(
    (event) => {
      event.preventDefault();

      console.log(inputs);
      if (inputs.text === "" || inputs.category_id === 0) {
        toast.error("لطفا متن را وارد کرده و دسته‌بندی را انتخاب نمایید.");
        return;
      }

      let data: InsertPreparedMessageRequest = {
        mtm: Date.now().toString().slice(0, -3),
        muid: userInfo.id,
        text: inputs.text,
        category_id: "" + inputs.category_id,
      };

      if (inputs.file_id !== 0) {
        data.file_id = "" + inputs.file_id;
      }

      InsertPreparedMessageAPI(data).then((res: InsertResponse) => {
        if (res.status) {
          toast.success("پیام با موفقیت اضافه شد.");
          resetInputs();
          getData();
        } else {
          toast.error("مشکلی در ثبت پیام بوجود آمده است. لطفا بعدا تلاش کنید.");
        }
      });
    },
    [inputs, userInfo.id, InsertPreparedMessageAPI, getData, resetInputs]
  );

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Modal
        className="prepared-message-modal"
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> پیام‌های آماده </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>افزودن پیام آماده جدید</Accordion.Header>
              <Accordion.Body>
                <form className="mb-4">
                  <CustomInput
                    inputContainer="mb-3"
                    label="متن پیام"
                    type="text"
                    inputType="textarea"
                    inputValue={inputs.text}
                    onChangeFunc={(event) =>
                      setInputs((prev) => ({
                        ...prev,
                        // @ts-ignore
                        text: event.target.value,
                      }))
                    }
                  />
                  <div>
                    <label
                      className="form-label"
                      style={{ color: "#677788", fontSize: "0.75rem" }}
                      htmlFor="category-select"
                    >
                      دسته‌بندی
                    </label>
                    <Select
                      id="category-select"
                      className="mb-3"
                      options={categories}
                      value={selectedCategory}
                      onChange={(newValue) =>
                        newValue?.value &&
                        setInputs((prev) => ({
                          ...prev,
                          category_id: +newValue.value,
                        }))
                      }
                      placeholder="دسته‌بندی"
                    />
                  </div>
                  <div>
                    <label
                      className="form-label"
                      style={{ color: "#677788", fontSize: "0.75rem" }}
                      htmlFor="file-input"
                    >
                      انتخاب فایل
                    </label>
                    <br />
                    <input
                      ref={fileRef}
                      className="mb-3"
                      id="file-input"
                      type="file"
                      onChange={fileHandler}
                    />
                  </div>
                  <div className="d-flex justify-content-center">
                    <CustomButton
                      color="success"
                      className="d-flex justify-content-center"
                      btnType="submit"
                      onClick={submitForm}
                      style={{ width: 100 }}
                    >
                      ثبت
                    </CustomButton>
                  </div>
                </form>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <hr />
          <PreparedMessagesTable
            messages={messages}
            categories={categories}
            receiver_id={receiver_id}
            deleteMessage={deleteMessage}
            selectedContact={selectedContact}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PreparedMessagesModal;
